<script>
  import { VueMaskDirective as mask } from 'v-mask'
  import ClickOut from '../../../../utils/directives/clickout'
  import Service from '../../../../domain/historico-alteracoes/services'
  import UPagination from '../../../_default/components/Uloc/Pagination'
  import { debounce } from 'lodash'
  import GrvService from '../../../../domain/grv/services/index'
  import PopupViewer from '../../../_default/components/popup-viewer/PopupViewer'
  import DetalhesLogAlteracao from './DetalhesLogAlteracao'
  import DataFiltroSelect from '../../grvs/components/grv-lista/DataFiltroSelect'

export default {
    components: {
      DataFiltroSelect,
      DetalhesLogAlteracao,
      UPagination,
      PopupViewer
    },
    nome: 'HistoricoAlteracoes',
    directives: {mask, ClickOut},
    data () {
      return {
        openCFilter: false,
        showFiltros: false,
        isLoading: false,
        isLoaded: false,
        data: null,
        entityid: null,
        listaGrvs: [],
        filtroInput: {
          id: null,
          data: ''
        },
        showOptionsAutocomplete: false,
        loading: false,
        paginationLimits: [25, 50, 100],
        pagination: {
          totalPages: 0,
          totalItems: 0,
          atualPage: 1,
          limit: 25
        },
        checkeds: 0,
        checkedAll: false,
        filtros: {
          busca: '',
          data: null,
          entityid: '',
          data1: '',
          data2: ''
        },
        filterKey: '',
        sortKey: '',
        sortOrders: {'date': 1},
        prevent: {},
        dblclick: 0,
        showDetalhes: false,
        logSelecionado: null
      }
    },
    computed: {
      filteredData: function () {
        let sortKey = this.sortKey
        let filterKey = this.filterKey && this.filterKey.toLowerCase()
        let order = this.sortOrders[sortKey] || 1
        let data = this.data
        if (filterKey) {
          data = data.filter(function (row) {
            return Object.keys(row).some(function (key) {
              return String(row[key]).toLowerCase().indexOf(filterKey) > -1
            })
          })
        }
        if (sortKey) {
          data = data.slice().sort(function (a, b) {
            a = a[sortKey]
            b = b[sortKey]
            return (a === b ? 0 : a > b ? 1 : -1) * order
          })
        }
        return data
      },
      noData () {
        let data = 'data'
        if (this[data] === null) return false
        return this[data].length === 0
      },
      iconSortingDirection () {
        return this.filtros.descending ? 'up' : 'down'
      }
    },
    mounted () {
      this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
    },
    activated () {
    },
    destroyed () {
    },
    methods: {
      reloadData (dates = {}) {
        if (this.filtros.data === 'Periodo') {
          let {data1, data2} = dates
          if (!data1 || !data2) return
          this.filtros.data1 = data1
          this.filtros.data2 = data2
        } else {
          this.filtros.data1 = ''
          this.filtros.data2 = ''
        }
        console.log(this.filtros)
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      },

      nextElement ({target}) {
        let index = parseInt(target.getAttribute('tabindex'))
        let next = index + 1
        document.querySelector('[tabindex="' + next + '"').focus()
      },

      loadData (limit, page, filtros, force) {
        this.data = null
        this.isLoading = true
        let pageNumber = this.$route.query.page
        if (pageNumber != null && typeof force === 'undefined') page = pageNumber
        Service.lista(limit, page, filtros)
          .then((response) => {
            this.isLoading = false
            this.data = response.data.result
            this.pagination.atualPage = response.data.offset
            this.pagination.totalPages = response.data.totalPages
            this.pagination.totalItems = response.data.total
          })
          .catch((response) => {
            this.isLoading = false
            console.log(response)
          })
      },

      changePage (page) {
        console.log('Change page ', page)
        this.pagination.atualPage = page
        this.$router.push({name: 'historico.alteracoes', query: {page: page}})
        this.loadData(this.pagination.limit, page, this.montaFiltros(), true)
      },

      montaFiltros () {
        let filtros = this.filtros
        let mount = ''
        for (let key in filtros) {
          if (filtros.hasOwnProperty(key)) {
            const val = filtros[key]
            if (val !== null) {
              mount += `&${key}=${val}`
            }
          }
        }
        return mount
      },
      sortResults (sortKey) {
        this.filtros.descending = !this.filtros.descending
        this.filtros.sortBy = sortKey
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      },

      pesquisar: debounce(function () { // debounce para evitar fazer mais de uma requisição no key event
        let busca = this.filtros.busca
        if (this.prevent.busca === busca) {
          return
        } // previne a repetição de uma chamada de api
        this.prevent.busca = busca
        this.pagination.atualPage = 1
        this.loadData(this.pagination.limit, this.pagination.atualPage, this.montaFiltros())
      }, 500),

      submit () {
        /* eslint-disable */

        const data = JSON.parse(JSON.stringify(this.data))
        const {id} = this.filtroInput
        if (!id) {
          let {id, titulo} = this.filtroInput
          if (id !== 0 && !id) {
            const regex = new RegExp(`^${titulo.toLowerCase()}$`)
            const match = this.listaGrvs.filter(item => {
              return item.placa.toLowerCase().match(regex) || item.numero.toLowerCase().match(regex)
            })
            if (match.length) {
              data.grv = match[0].id
            } else {
              alert('Grv não encontrada')
              this.$loaderOverlay.hide()
              return
            }
          }
        } else {
          data.grv = id
        }
      },

      getListaGrvs: debounce(function () {
        this.listaGrvs = []
        this.filtroInput.id = null
        this.loading = true
        const filtro = this.filtroInput.titulo.split(' - ')[0]
        if (filtro) {
          this.setVisibilityOptionsAutocomplete(true)
          GrvService.listaSimples(this.filtroInput.titulo)
            .then(result => {
              this.listaGrvs = result.data
              this.loading = false
            })
            .catch(error => {
              console.log(error)
              alert('Erro ao carregar lista de grvs')
              this.loading = false
            })
        } else {
          this.loading = false
          this.setVisibilityOptionsAutocomplete(false)
        }
      }, 300),
      setFiltroInput (filtro) {
        this.filtroInput = {...filtro}
        this.filtroInput.titulo = `${filtro.numero} - ${filtro.placa}`
        this.filtros.entityid = filtro.id
      },
      setVisibilityOptionsAutocomplete (status) {
        setTimeout(() => {
          this.showOptionsAutocomplete = status
        }, 100)
      },
      openDetalhes (log) {
        this.logSelecionado = log
        this.showDetalhes = true
      },
      closeDetalhes () {
        this.logSelecionado = null
        this.showDetalhes = false
      }
    },
    watch: {
      filtros: function (val) {
        console.log('Mudou')
      }
    }
  }
</script>

<template>
  <transition name="slide" appear>
    <div class="app-content-body fade-in-up content-transition">
      <div class="hbox hbox-auto-xs hbox-auto-sm">
        <div class="col">
          <div class="r">

            <div class="bg-light lter b-b wrapper-md">
              <div class="row">
                <div class="col-sm-6 col-xs-12">
                  <h1 class="font-thin h3">
                    Histórico de alterações dos usuários do sistema <span class="badge">{{pagination.totalItems}}</span>
                  </h1>
                  <small class="text-muted">
                    <!--<ordenar-arrematante></ordenar-leilao>-->
                  </small>
                </div>
                <div class="col-sm-6 col-xs-12">
                  <div class="text-right text-left-xs">
                  </div>
                </div>
              </div>
            </div>

            <div class="panel panel-default">
              <div class="wrapper clearfix">
                <div class="col-sm-7 m-b-xs">
                  <div class="col-md-6">
                    <data-filtro-select @change="reloadData" v-model="filtros.data" label="Filtrar por data"></data-filtro-select>
                  </div>
                </div>
                <div class="col-sm-5">
                  <div class="input-group">
                    <div class="input-group-btn">
                      <a class="btn btn-sm btn-default"><span class="m-r-xs font-bold"></span>Buscar</a>
                    </div>
                    <input type="text" class="input-sm form-control" v-model="filtros.busca" @keyup="pesquisar"
                           placeholder="Pesquisar">
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <table class="table table-hover table-striped b-t b-light">
                  <thead>
                  <tr>
                    <th>Data</th>
                    <th>Usuário</th>
                    <th>Descrição</th>
                    <th>Entidade alterada</th>
                  </tr>
                  </thead>
                  <tbody>
                  <!-- FAKE -->
                  <tr v-if="isLoading" v-for="i in [1,2,3]">
                    <td class="v-middle">
                      <u-fake-loader width="100px" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                    </td>
                    <td role="button" tabindex="0">
                      <a class="text-cap custom-link ">
                        <u-fake-loader width="100%" class="m-t"></u-fake-loader>
                      </a>
                    </td>
                  </tr>
                  <tr v-for="log in filteredData" style="cursor: pointer" @click="openDetalhes(log)">
                    <td class="v-middle">{{ moment(log.data.date).format('DD/MM/YYYY HH:mm:ss')}}</td>
                    <td :class="`v-middle ${!log.username && 'text-center'}`" role="button" tabindex="0" >{{ log.username || '-' }}</td>
                    <td class="v-middle" role="button" tabindex="0">{{ log.descricao }}</td>
                    <td class="v-middle" role="button" tabindex="0">{{ log.entidade }}</td>
                  </tr>

                  <tr v-if="!filteredData || filteredData.length === 0">
                    <td colspan="6">Nenhum registro encontrado</td>
                  </tr>

                  </tbody>
                </table>
              </div>
              <footer class="panel-footer">
                <div class="row">
                  <div class="col-sm-4 hidden-xs">
                    Mostrar:
                    <select @change="changePage(1)" v-model="pagination.limit"
                            class="input-sm form-control w-auto inline v-middle">
                      <option v-for="p in paginationLimits" :value="p">{{ p }}</option>
                    </select>
                    por página
                  </div>
                  <div class="col-sm-2 text-center">
                    <small class="text-muted inline m-t-sm m-b-sm ">{{ pagination.atualPage }} / {{ pagination.totalPages }} </small>
                  </div>
                  <div class="col-sm-6 text-right text-center-xs">
                    <u-pagination @changePage="changePage" :atual="pagination.atualPage" :total="pagination.totalPages"></u-pagination>
                  </div>
                </div>
              </footer>
            </div>

          </div>
        </div>
        <!-- /.col -->
      </div>
      <popup-viewer v-if="showDetalhes" @close="closeDetalhes" :title="`Detalhes do log #${logSelecionado.id}`">
        <detalhes-log-alteracao :log-selecionado="logSelecionado"></detalhes-log-alteracao>
      </popup-viewer>
    </div>
  </transition>
</template>

<style scoped>
  .filtros-periodo-datas {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* Raphael */
  .autocomplete-input {
    position: relative;
  }
  .autocomplete-input input {
    width: 70%;
    float: left;
  }
  .autocomplete-input ul {
    position: absolute;
    border: #999 1px solid;
    list-style-type: none;
    width: 70%;
    max-height: 100px;
    overflow: auto;
    background-color: #fff;
    z-index: 99;
  }
  .autocomplete-input ul li {
    padding: 5px;
    cursor: pointer;
  }
  .autocomplete-input ul li:hover {
    background-color: #fff;
    color: #333;
  }
</style>



// WEBPACK FOOTER //
// HistoricoAlteracoes.vue?292c90de